// Core
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

// Rxjs
import { Observable, of } from 'rxjs';
import { map, take, filter, switchMap } from 'rxjs/operators';

// Libs
import { Store, select } from '@ngrx/store';

// Store
import { User, USER_ROLE } from '@app/domains/user/models';
import { UserService } from '@app/domains/user/services/user.service';
import { AuthFacade } from '@app/domains/auth/store/facade';


@Injectable({
  providedIn: 'root'
})
export class PartnersGuard implements CanActivate, CanLoad {
  constructor(
    private auth: AuthFacade,
    private userService: UserService,
    private router: Router) { }

  private checkUserRole() {
    return this.auth.token$.pipe(
      take(1),
      switchMap((t) => {
        const [token, user] = t.token.split(".");
        const email = JSON.parse(atob(user)).sub;
        return this.userService.getUser(email);
      }),
      map((user: User) => {
        const allowed = user.roles && user.roles.includes(USER_ROLE.SUPERVISOR);
        if (!allowed) {
          this.router.navigate(['main']);
        }
        return allowed;
      })
    );
  }

  canActivate(): Observable<boolean> {
    return this.checkUserRole();
  }

  canLoad(): Observable<boolean> {
    return this.checkUserRole();
  }
}
